import React, { useRef, useState } from 'react'
import DoneIcon from '@mui/icons-material/Done'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import BigModal from '../../../../../components/Modals/BigModal'
import {
  Alert,
  Chip,
  MenuItem,
  OutlinedInput,
  Snackbar,
  Stack,
} from '@mui/material'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AnDateField from '../../../../../components/DateTime/DateField'
import TextField from '@mui/material/TextField'
import moment from 'moment'
import SmallModal from '../../../../../components/Modals/SmallModal'
import Select from '@mui/material/Select'
import { useTheme } from '@emotion/react'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import API from '../../../../../services/API'
import ShowAllDrivingLicenceChecks from './ShowAllDrivingLicenceChecks'

const DrivingLicence = ({
  driverDetails,
  latestCheck,
  employeeID,
  loadEmployee,
}) => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const [date, setDate] = useState(moment())
  const [licenceIssueNumber, setLicenceIssueNumber] = useState('')
  const [validFrom, setValidFrom] = useState(null)
  const [validTo, setValidTo] = useState(null)
  const [drivingStatus, setDrivingStatus] = useState('')
  const [endorsements, setEndorsements] = useState([])
  const [activePoints, setActivePoints] = useState(0)
  const [categories, setCategories] = useState(['B1', 'B', 'BE', 'F'])
  const [riskAssessment, setRiskAssessment] = useState('')
  const [openNewEndorsement, setOpenNewEndorsement] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const theme = useTheme()
  const holdsLicence = !!driverDetails?.licenceNumber
  // TODO: FILE UPLOAD

  const categoryOptions = [
    'AM',
    'A1',
    'A2',
    'A',
    'B1',
    'B auto',
    'BE',
    'C1',
    'C1E',
    'C',
    'CE',
    'D1',
    'D1E',
    'D',
    'DE',
    'f',
    'G',
    'H',
    'k',
    'l',
    'M',
    'n',
    'P',
    'Q',
  ]
  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/driving-licence-check', {
      employeeID,
      date,
      licenceIssueNumber,
      validFrom,
      validTo,
      drivingStatus,
      endorsements,
      activePoints,
      riskAssessment,
      categories,
    }).then((res) => {
      if (res.status === 200) {
        loadEmployee()
        setOpenAddNew(false)
        setSubmitSuccess(true)
      }
    })
  }

  const AddEndorsement = ({}) => {
    const [code, setCode] = useState('')
    const [points, setPoints] = useState(0)
    const [offenceDate, setOffenceDate] = useState(null)
    const [expiryDate, setExpiryDate] = useState(null)
    const [description, setDescription] = useState('')
    const handleAddEndorsement = (e) => {
      e.preventDefault()
      setEndorsements((prev) => [
        ...prev,
        { code, points, offenceDate, expiryDate, description },
      ])
      setOpenNewEndorsement(false)
    }
    return (
      <SmallModal
        open={openNewEndorsement}
        onClose={() => setOpenNewEndorsement(false)}
      >
        <Stack component="form" onSubmit={handleAddEndorsement} gap={1}>
          <Typography variant="title3">Add Endorsement</Typography>
          <TextField
            value={code}
            onChange={(e) => setCode(e.target.value)}
            label="Code"
            required
            autoComplete="off"
          />
          <TextField
            value={points}
            onChange={(e) => e.target.value >= 0 && setPoints(e.target.value)}
            label="Points"
            type="number"
            required
            autoComplete="off"
          />
          <AnDateField
            date={offenceDate}
            onChange={(newDate) => setOffenceDate(newDate)}
            label="Offence Date"
            required
          />
          <AnDateField
            date={expiryDate}
            onChange={(newDate) => setExpiryDate(newDate)}
            label="Expiry Date"
            required
          />
          <TextField
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            label="Description"
            autoComplete="off"
          />
          <Button type="submit" variant="contained">
            Submit Endorsement
          </Button>
        </Stack>
      </SmallModal>
    )
  }

  return (
    <Grid item xs={12} lg={6}>
      <DetailsBox
        title="Driving Licence"
        noBorder
        rows={[
          {
            label: 'Licence Number',
            value: driverDetails.licenceNumber || 'No licence held',
            fullWidth: true,
          },
          {
            label: 'Licence Expiry',
            value: driverDetails?.licenceExpiry
              ? moment(driverDetails.licenceExpiry).format('Do MMM YYYY')
              : '-',
            fullWidth: true,
          },
          {
            label: 'Has C1',
            value: driverDetails.hasC1 ? 'Yes' : 'No',
          },
          {
            label: 'Blue Light Driver',
            value: driverDetails.hasBlueLight ? 'Yes' : 'No',
          },
          {
            label: 'Permitted To Drive',
            value: driverDetails.permissionToDrive ? 'Yes' : 'No',
          },
          {
            label: 'Latest Check',
            value: latestCheck?.date
              ? moment(latestCheck?.date).format('Do MMM YYYY')
              : holdsLicence
                ? '-'
                : 'Not required',
          },
        ]}
        buttonRight={
          <Button
            size="small"
            variant="outlined"
            color="contrast"
            onClick={() => setOpenAddNew(true)}
          >
            Add Licence Check
          </Button>
        }
      >
        <Box display="flex" justifyContent="center">
          {/* TODO */}
          <Button
            onClick={() => setShowAll(true)}
            variant="contained"
            color="contrast"
            size="small"
          >
            View All Licence Checks
          </Button>
        </Box>
      </DetailsBox>
      <ShowAllDrivingLicenceChecks
        open={showAll}
        onClose={() => setShowAll(false)}
        employeeID={employeeID}
      />
      <BigModal open={openAddNew} onClose={() => setOpenAddNew(false)}>
        <Stack gap={1} component="form" onSubmit={handleSubmit}>
          <Box component={Paper} padding={1}>
            <Stack gap={1}>
              <Typography variant="title2">
                Record new Driving Licence Check
              </Typography>
              <Stack
                direction={{ xs: 'column', lg: 'row' }}
                gap={{ xs: 2, lg: 1 }}
                flexWrap="wrap"
              >
                <AnDateField
                  date={date}
                  onChange={(newDate) => setDate(newDate)}
                  label="Date of Check"
                  sx={{ flex: 1 }}
                  required
                />
                <TextField
                  label="Licence Issue Number"
                  value={licenceIssueNumber}
                  onChange={(e) => setLicenceIssueNumber(e.target.value)}
                  autoComplete="off"
                  required
                />
                <AnDateField
                  date={validFrom}
                  onChange={(newDate) => setValidFrom(newDate)}
                  label="Valid From"
                  sx={{ flex: 1 }}
                  required
                />
                <AnDateField
                  date={validTo}
                  onChange={(newDate) => setValidTo(newDate)}
                  label="Valid To"
                  sx={{ flex: 1 }}
                  required
                />
                <TextField
                  value={drivingStatus}
                  onChange={(e) => setDrivingStatus(e.target.value)}
                  label="Driving Status"
                  sx={{ flex: 2 }}
                  autoComplete="off"
                  required
                />
                {/* TODO: Endorsements */}
                <TextField
                  type="number"
                  value={activePoints}
                  onChange={(e) =>
                    e.target.value >= 0 && setActivePoints(e.target.value)
                  }
                  label="Active Points"
                  autoComplete="off"
                />
                {/* TODO: Risk Assessment */}
                {/* TODO: Attachments */}
              </Stack>
            </Stack>
          </Box>
          <Stack direction={{ xs: 'column', lg: 'row' }} spacing={1}>
            <Box component={Paper} padding={1} height="auto" flex={1}>
              <DetailsBox
                title="Endorsements"
                buttonRight={
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => setOpenNewEndorsement(true)}
                  >
                    Add New
                  </Button>
                }
              >
                <Stack>
                  {endorsements.map((endorsement) => (
                    <Stack
                      gap={1}
                      key={endorsement.code + endorsement.offenceDate.toString}
                      border="solid 1px #3E4E50"
                      borderRadius={1}
                      padding={0.5}
                    >
                      <Box
                        display="flex"
                        gap={1}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Chip
                          size="small"
                          label={endorsement?.code}
                          color="warning"
                          sx={{ borderRadius: 1 }}
                        />
                        <Typography>{endorsement.description}</Typography>
                        <Chip
                          size="small"
                          label={`${endorsement.points} points`}
                          color="error"
                          sx={{ borderRadius: 1 }}
                        />
                      </Box>
                      <Box display="flex" gap={1}>
                        <Box display="flex" gap={0.5} alignItems="center">
                          <Typography variant="caption">Date:</Typography>
                          <Typography>
                            {moment(endorsement.offenceDate)
                              .format('DD/MM/YYYY')
                              .toString()}
                          </Typography>
                        </Box>
                        <Box display="flex" gap={0.5} alignItems="center">
                          <Typography variant="caption">Expires:</Typography>
                          <Typography>
                            {moment(endorsement.expiryDate)
                              .format('DD/MM/YYYY')
                              .toString()}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  ))}
                </Stack>
              </DetailsBox>
            </Box>
            <Box component={Paper} padding={1} flex={1}>
              <DetailsBox title="Categories">
                <Box display="flex" gap={0.5} flexWrap="wrap">
                  {categoryOptions.map((c) => {
                    const isChecked = categories.includes(c)
                    return (
                      <Box
                        display="flex"
                        key={c}
                        padding={0.5}
                        // width="5rem"
                        sx={{ cursor: 'pointer' }}
                        borderRadius={1}
                        bgcolor={isChecked && theme.palette.success.main}
                        // alignItems='center'
                        // gap={0.2}
                        color={isChecked ? 'whitesmoke' : '#3E4E50'}
                        // border={`solid 1px ${isChecked ? theme.palette.success.main : '#3E4E50'}`}
                        onClick={() =>
                          isChecked
                            ? setCategories((prev) =>
                                prev.filter((x) => x !== c),
                              )
                            : setCategories((prev) => [...prev, c])
                        }
                      >
                        <Box display="flex">
                          {isChecked ? (
                            <CheckBoxIcon />
                          ) : (
                            <CheckBoxOutlineBlankIcon />
                          )}
                        </Box>
                        <Box display="flex">{c}</Box>
                      </Box>
                    )
                  })}
                </Box>
              </DetailsBox>
            </Box>
            <Box
              component={Paper}
              padding={1}
              flex={1}
              alignItems="space-between"
              display="flex"
              flexDirection="column"
              gap={1}
            >
              <Stack flex={1}>
                <DetailsBox title="Notes" />
                <TextField
                  multiline
                  minRows={3}
                  value={riskAssessment}
                  onChange={(e) => setRiskAssessment(e.target.value)}
                  placeholder="Enter Comments Here"
                />
              </Stack>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                color="success"
              >
                Submit
              </Button>
            </Box>
          </Stack>
        </Stack>
        <AddEndorsement />
      </BigModal>
      <Snackbar
        open={submitSuccess}
        onClose={() => setSubmitSuccess(false)}
        autoHideDuration={5000}
      >
        <Alert severity="success">
          Driving Licence Check Successfully Submitted
        </Alert>
      </Snackbar>
    </Grid>
  )
}

export default DrivingLicence
